import { render, staticRenderFns } from "./directPay-collection.vue?vue&type=template&id=55f3315a&scoped=true&"
import script from "./directPay-collection.vue?vue&type=script&lang=js&"
export * from "./directPay-collection.vue?vue&type=script&lang=js&"
import style0 from "./directPay-collection.vue?vue&type=style&index=0&id=55f3315a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f3315a",
  null
  
)

export default component.exports